jQuery(document).ready(function () {
  jQuery(".js-mobile-nav-toggle").click(function () {
    jQuery("body").toggleClass("hup_scroll-fix");
  });
  jQuery('.hup_site-nav > .site-nav--has-dropdown').hover(
    function () {
      jQuery(this).addClass('hup_site-hover');
      jQuery(this).parents('ul,nav').addClass('hup_site-hover')

    },
    function () {
      jQuery(this).removeClass('hup_site-hover');
      jQuery(this).parents('ul,nav').removeClass('hup_site-hover')
    }
  )
});

jQuery(document).ready(function () {
	jQuery(".rc_block__type__autodeliver").click(function () {
      jQuery(".shopify-payment-button").hide();
    });
    jQuery(".rc_block__type__onetime").click(function () {
      jQuery(".shopify-payment-button").show();
    });
});

jQuery(document).ready(function () {
  $('.cst_radios').click(function(){ 
    var val = $(this). val();
    $('.rc_select').val(val).trigger('change');
  })
});

      
jQuery(document).ready(function(){
  jQuery(".popup-learn-more").click(function(){
    jQuery(".rc_custom_popup").addClass("show");
    jQuery(".rc_radio__autodeliver").click();
    jQuery("body").addClass("hide-scroll");
  });
  jQuery(".popup-close-cst").click(function(){
    jQuery(".rc_custom_popup").removeClass("show");
    jQuery("body").removeClass("hide-scroll");
  });
});


// Redesign Recharge Widget Start
jQuery(document).ready(function () {
  var checkExist = setInterval(function () {
    if (jQuery('.rc-selling-plans.rc_widget__option__plans').length) {
      extraTicketAttachment();
      clearInterval(checkExist);
    }
  }, 300); 

  function extraTicketAttachment() {
    jQuery(".rc-selling-plans.rc_widget__option__plans")
      .prepend(`
           <div class="after-subscribe-details hw--after-subscribe-details" style="padding-left: 0;">
              <p><svg viewBox="0 0 50 50" width="16px" height="16px">
                      <path
                          d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z">
                      </path>
                  </svg> No obligation - modify or cancel anytime without penalty</p>
              <p><svg viewBox="0 0 50 50" width="16px" height="16px">
                      <path
                          d="M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z">
                      </path>
                  </svg> Easy to manage - we email you 3 days before each order</p>
          </div>
      `);
  }
});


jQuery(document).ready(function () {
  var checkExist = setInterval(function () {
    if (jQuery('.rc-option__price.rc_widget__price.rc_widget__price--subsave').length) {
      extraTicketAttachment();
      clearInterval(checkExist);
    }
  }, 300); 

  function extraTicketAttachment() {
    jQuery(".rc-option__price.rc_widget__price.rc_widget__price--subsave")
      .before(`
          <span class="funCall hw--funCall">Learn More</span>
      `);
  }
});


jQuery(document).ready(function () {
    var intervalId = setInterval(function() {
        $('span.funCall.hw--funCall').on('click', function() {
            $('#hw__rc_custom_popup').addClass('your-class');
            $('body').addClass('no-scroll');
            clearInterval(intervalId);
        });
        $('.popup-close-cst').on('click', function() {
            $('#hw__rc_custom_popup').removeClass('your-class');
            $('body').removeClass('no-scroll');
            clearInterval(intervalId);
        });
    }, 300);
});

//Redesign Recharge Widget End 